import { toast } from 'react-toastify';

//const API_URL = 'http://localhost:8081/api/jobs';
const API_URL = 'https://alpha.currentjobs.co.ke/api/jobs/cl';

// ✅ Public: Fetch paginated jobs
export const fetchJobs = async (page, size) => {
  try {

    {/**const res = await fetch(`${API_URL}?page=${page}&size=${size}`);**/}
    const res = await fetch(`${API_URL}/viewactive?page=${page}&size=${size}`);
    if (!res.ok) throw new Error(`Fetch jobs failed: ${res.status}`);
    return res.json();
  } catch (error) {
    {/**console.error('Fetch Jobs Error:', error);**/}
    toast.error('Failed to load job listings');
    //throw error;
  }
};

// ✅ Public: Fetch job details by ID
export const fetchJobById = async (id) => {
  

  const response = await fetch(`${API_URL}/viewjob/${id}`);

  if (!response.ok) {

    toast.error('Failed to fetch job details');
  }

  return response.json();
};




export const filterJobs = async (filterRequest = {}) => {
  try {
    const { page, size, ...filters } = filterRequest;

    // ✅ Extract only one filter key and its value (e.g., { educationLevel: "Diploma" })
    const filterEntry = Object.entries(filters).find(([_, val]) => val !== undefined && val !== '');

    if (!filterEntry) {
      toast.error('No valid filter provided');
      return [];
    }

    const [key, value] = filterEntry;

    // Build query params
    const query = {
      [key]: value,
    };

    if (page !== undefined) query.page = page;
    if (size !== undefined) query.size = size;

    // Convert to query string
    const queryString = new URLSearchParams(query).toString();

    // Final backend URL
    const url = `${API_URL}/filter?${queryString}`;

    console.log('📡 Filter URL:', url); // Logs the real API URL

    // Make the GET request
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!res.ok) throw new Error('Job filtering failed');

    return res.json();
  } catch (error) {
    console.error('Filter Error:', error);
    toast.error('Failed to apply filters');
    return [];
  }
};




/**
export const filterJobs = async (filterRequest) => {
  
  try {
    
    const res = await fetch(`${API_URL}/filter`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(filterRequest)
    });

    if (!res.ok) throw new Error('Job filtering failed');
    return res.json();
  } catch (error) {

    toast.error('Failed to apply filters');
    return []; // Fallback to empty array
    
  }
};
*/
export const fetchActiveJobCount = async () => {
  
  try {
    const res = await fetch(`${API_URL}/count/active`);
    if (!res.ok) throw new Error('Failed to fetch active job count');
    return res.json();
  } catch (err) {
    toast.error('Failed to fetch active jobs count');
    return 0;
  }
};

// ✅ Public: Fetch jobs by company name
export const fetchJobByCompanyNamee = async (company_name) => {
  

  const response = await fetch(`${API_URL}/vieworgjobs/${company_name}`);

  if (!response.ok) {

    toast.error('Failed to fetch job by company name');
  }

  return response.json();
};

// ✅ Public: Fetch jobs by company name
export const fetchJobByCompanyNamem = async (company_name) => {
  try {
    const response = await fetch(`${API_URL}/vieworgjobs/${encodeURIComponent(company_name)}`);

    if (!response.ok) {
      toast.error('Failed to fetch jobs by company');
      console.warn(`Status ${response.status} from fetchJobByCompanyName`);
      return [];
    }

    const data = await response.json();
    return Array.isArray(data) ? data : [];

  } catch (error) {
    console.error('Error fetching jobs by company name:', error);
    toast.error('Something went wrong while fetching jobs by company');
    return [];
  }
};


export const fetchJobByCompanyName = async (company_name) => {
  try {
    const response = await fetch(`${API_URL}/vieworgjobs/${company_name}`);
    if (!response.ok) {
      throw new Error('Failed to fetch job by company name');
    }
    return await response.json();
  } catch (error) {
    console.warn('Company jobs fetch failed:', error.message);
    return []; // Fallback to empty array
  }
};
